export {};
//# sourceMappingURL=IPerfManager.js.map